import { render, staticRenderFns } from "./AlertCogTooth.vue?vue&type=template&id=c2c8ae4a"
import script from "./AlertCogTooth.vue?vue&type=script&lang=js"
export * from "./AlertCogTooth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports